<div class="satellite-images-admin-page">
  <div class="page-header">
    <div class="header-left">
      <button class="back-btn" (click)="goBack()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <h1 class="section-title">{{ 'Logging' | translate }}</h1>
    </div>
    <div class="header-right">
      <span class="filter-label">{{ 'Filters' | translate}}</span>
      <svg class="filter-icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

  <div class="page-content">
    <div class="table-section">
      <app-data-table
        [data]="requestsData"
        [columns]="tableColumns"
        [loading]="false">
        <ng-template #checkboxColumn let-row="$implicit">
          <app-checkbox
            [ngModel]="isRequestSelected(row.id)"
            (onChange)="toggleRequestSelection(row.id)">
          </app-checkbox>
        </ng-template>
      </app-data-table>

      <div class="results-info">
        {{ totalResultsText }}
      </div>
    </div>
    <div class="filters-sidebar">
      <div class="sidebar-content">
        <div class="filter-group">
          <label>{{ 'Пользователь' | translate}}</label>
          <app-date-picker
            [(ngModel)]="selectedPeriod"
            [placeholder]="'01.05.2024'"
            [showIcon]="true"
            [dateFormat]="'dd.mm.yy'">
          </app-date-picker>
        </div>

        <div class="filter-group">
          <label>{{ 'Satellite' | translate }}</label>
          <app-dropdown
            [(ngModel)]="selectedSatellite"
            [options]="satelliteOptions"
            [placeholder]="'satellite.image.filter.data_source.placeholder'">
          </app-dropdown>
        </div>

        <div class="filter-group">
          <label>{{ 'Region' | translate }}</label>
          <app-dropdown
            [(ngModel)]="selectedRegion"
            [options]="regionOptions"
            [placeholder]="'Все регионы'">
          </app-dropdown>
        </div>

        <div class="filter-group">
          <label>{{ 'Period' | translate }}</label>
          <app-date-picker
            [(ngModel)]="selectedPeriod"
            [placeholder]="'Period'"
            [showIcon]="true"
            [dateFormat]="'dd.mm.yy'">
          </app-date-picker>
        </div>

        <div class="filter-group">
          <label>{{ 'Статус' | translate}}</label>
          <app-dropdown
            [(ngModel)]="selectedStatus"
            [options]="statusOptions"
            [placeholder]="'Теги'">
          </app-dropdown>
        </div>

        <div class="filter-group">
          <label>{{ 'Класс событий' | translate }}</label>
          <app-dropdown
            [(ngModel)]="selectedEventClass"
            [options]="eventClassOptions"
            [placeholder]="'Классы событий'">
          </app-dropdown>
        </div>

        <div class="filter-group">
          <label>{{ 'Теги' | translate }}</label>
          <div class="tags-container">
            <span class="tag-label">{{ 'All' | translate }}</span>
            <div class="selected-tags">
              <div *ngFor="let tag of selectedTags" class="tag-item">
                <span>{{ tag }}</span>
                <button class="tag-remove" (click)="removeTag(tag)">×</button>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-actions">
          <app-button [variant]="'primary'" [fullWidth]="true" (onClick)="applyFilters()">
            {{ 'Применить' | translate}}
          </app-button>
          <app-button [variant]="'primary'" [fullWidth]="true" (onClick)="exportData()">
            {{ 'Export' | translate}}
          </app-button>
          <app-button [variant]="'secondary'" [fullWidth]="true" (onClick)="resetFilters()">
            {{ 'Reset filter' | translate}}
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
